import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetColorCodes,
  CreateColorCode,
  UpdateColorCode,
  DeleteColorCode,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const colorCodeQueryKeys = {
  colorCodes: () => ["colorCodes"] as const,
};

export const invalidateColorCodeQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["colorCodes"] });
};

export const useColorCodesQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: colorCodeQueryKeys.colorCodes(),
    queryFn: async () => unwrapApiResponse(await GetColorCodes()),
  });
};

export const useCreateColorCodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateColorCode>[0]) =>
      CreateColorCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateColorCodeQueries(queryClient);
      }
    },
  });
};

export const useUpdateColorCodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateColorCode>[0]) =>
      UpdateColorCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateColorCodeQueries(queryClient);
      }
    },
  });
};

export const useDeleteColorCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteColorCode>[0]) =>
      DeleteColorCode(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateColorCodeQueries(queryClient);
      }
    },
  });
};
